module.exports = __webpack_public_path__ + "img/120.dfc27bf7.jpg";